<mat-sidenav-container>
  <nav class="navbar">
    <div class="navbar-content">
      <a href="" class="sidebar-toggler" (click)="toggleSidebar($event)">
        <i class="feather icon-menu"></i>
      </a>
      <div class="logo-mini-wrapper">
        <img src="../../../../assets/images/callcare/TSCSS_Logo_3.png" class="logo-mini logo-mini-light" alt="logo">
        <img src="../../../../assets/images/callcare/TSCSS_Logo_3.png" class="logo-mini logo-mini-dark" alt="logo">
      </div>

      <!-- ── Dynamic Page Header (Extraction Workspace, etc) ── -->
      <div class="dynamic-header-section" *ngIf="dynamicHeader">
        <div class="header-breadcrumb">
          <h1 class="header-title">{{ dynamicHeader.title }}</h1>
          <p class="header-subtitle" *ngIf="dynamicHeader.subtitle" [innerHTML]="dynamicHeader.subtitle"></p>
        </div>

        <div class="header-actions">
          <ng-container *ngFor="let action of dynamicHeader.actions">
            <!-- Normal Button -->
            <button *ngIf="!action.toggle" mat-button [class]="'action-btn ' + (action.class || '')"
              (click)="onHeaderAction(action)" [matTooltip]="action.tooltip">
              <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
              <span>{{ action.label }}</span>
            </button>

            <!-- Toggle Style Button -->
            <button *ngIf="action.toggle" mat-stroked-button
              [class]="'action-btn toggle-btn ' + (action.active ? 'active ' : '') + (action.class || '')"
              (click)="onHeaderAction(action)" [matTooltip]="action.tooltip">
              <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
              <span>{{ action.label }}</span>
            </button>
          </ng-container>
        </div>
      </div>

      <ul class="navbar-nav">
        <li class="theme-switcher-wrapper nav-item">
          <!-- <div *ngIf="showDialerButton" class="dialer-icon-wrapper">
            <button mat-fab extended class="dialer-fab-btn" type="button"
              (click)="openSidebar()" matTooltip="Open Dialer">
              <mat-icon class="dialer-fab-icon">phone_in_talk</mat-icon>
              <span class="dialer-fab-label">Dialer</span>
            </button>
          </div> -->

          <!-- Incoming Call Notification/Tab -->
          <div *ngIf="callerInfo && showTabDialer"
            class="incoming-call-info ms-3 p-2 bg-light border rounded shadow-sm d-flex align-items-center">
            <mat-icon class="text-primary me-2">call_received</mat-icon>
            <div>
              <p class="mb-0 fw-bold fs-12px">{{callerInfo.callerName}}</p>
              <p class="mb-0 text-muted fs-11px">{{callerInfo.callerPhoneNumber}}</p>
              <span *ngIf="callerInfo.found" class="badge bg-success fs-10px">Existing Customer</span>
              <span *ngIf="!callerInfo.found" class="badge bg-info fs-10px">New Caller</span>
            </div>
            <button mat-icon-button (click)="showTabDialer = false" class="ms-2">
              <mat-icon>close</mat-icon>
            </button>
          </div>

        </li>

        <li class="nav-item dropdown" ngbDropdown>
          <a class="nav-link dropdown-toggle profile-toggle" ngbDropdownToggle id="profileDropdown" role="button">
            <div class="nav-profile">
              <div class="avatar-wrapper">
                <img src="../../../../assets/images/callcare/user-avtar.png"
                  onerror="this.src='https://via.placeholder.com/80?text=Admin'" class="profile-img" alt="profile">
                <span class="status-indicator online"></span>
              </div>
            </div>
          </a>
          <div class="dropdown-menu dropdown-glass dropdown-menu-end" ngbDropdownMenu aria-labelledby="profileDropdown">
            <div class="profile-dropdown-header">
              <div class="dropdown-avatar-wrap">
                <img src="../../../../assets/images/callcare/user-avtar.png"
                  onerror="this.src='https://via.placeholder.com/80?text=Admin'" alt="avatar">
                <div class="profile-ring"></div>
              </div>
              <div class="dropdown-user-info">
                <h6 class="dropdown-name">{{ userName || 'Admin User' }}</h6>
                <p class="dropdown-role">{{ userRole || 'admin@tscti.com' }}</p>
              </div>
            </div>
            <div class="dropdown-body">
              <!-- Intelligence Quick Stats -->
              <ul class="dropdown-list">
                <li class="logout-item">
                  <a href="javascript:void(0);" class="dropdown-link logout" (click)="onLogout($event)">
                    <mat-icon>logout</mat-icon>
                    <span>Logout</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</mat-sidenav-container>